import { Fragment } from 'react'

import { DesktopNav, MobileNav } from '@/templates/Inc/Nav'
function Header() {
  return (
    <Fragment>
      <MobileNav />
      <DesktopNav />
    </Fragment>
  )
}

export default Header
